import request from "superagent";
import Model from "../model";
import * as actions from "./actions";
import { store } from "/app/src/store";
import { toast } from "react-toastify";

class QuickResponse extends Model {
  read() {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();

      dispatch(actions.quickResponseReadRequest(true));
      return request
        .post(`${url}/v1/company/quick_response/get`)
        .send({})
        .set("Authorization", `Bearer ${token}`)
        .accept("application/json")
        .set("Content-Type", "application/json")
        .end((err, res) => {
          if (res.statusCode === 200) {
            const quickResponses = res.body.quick_responses;

            quickResponses.sort(function (a, b) {
              return a.id - b.id;
            });

            dispatch(actions.quickResponseReadSuccess(quickResponses));
          } else {
            dispatch(actions.quickResponseReadFailure(err, res));
          }
        });
    };
  }

  create(title, quickResponse) {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();
      dispatch(actions.quickResponseCreateRequest(true));

      return request
        .post(`${url}/v1/company/quick_response/create`)
        .send({
          quick_response: quickResponse,
          title: title,
        })
        .set("Authorization", `Bearer ${token}`)
        .accept("application/json")
        .set("Content-Type", "application/json")
        .end((err, res) => {
          if (res.statusCode === 200) {
            const newQuickResponse = res.body.quick_response;

            //store.dispatch(quick_responseCreated(QnA));
            dispatch(actions.quickResponseCreateSuccess(newQuickResponse));
            toast.success("Ny snabbsvar skapades");
          } else {
            dispatch(actions.quickResponseCreateFailure(err, res));
          }
        });
    };
  }

  delete(id) {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();
      dispatch(actions.quickResponseDeleteRequest(true));

      return request
        .post(`${url}/v1/company/quick_response/delete`)
        .send({
          quick_response_id: id,
        })
        .set("Authorization", "Bearer " + token)
        .accept("application/json")
        .set("Content-Type", "application/json")
        .end((err, res) => {
          if (res.statusCode === 200) {
            store.dispatch(actions.quickResponseDeleteSuccess(id));
            toast.success("Snabbsvar borttagen");
          } else {
            store.dispatch(actions.quickResponseDeleteFailure(err, res));
          }
        });
    };
  }

  update(id, title, body) {
    return (dispatch) => {
      const url = this.url();
      const token = this.token();
      dispatch(actions.quickResponseUpdateRequest(true));

      return request
        .post(`${url}/v1/company/quick_response/update`)
        .send({
          quick_response: body,
          quick_response_id: id,
          title: title,
        })
        .set("Authorization", "Bearer " + token)
        .accept("application/json")
        .set("Content-Type", "application/json")
        .end((err, res) => {
          if (res.statusCode === 200) {
            const body = res.body.quick_response;
            const id = res.body.quick_response.id;
            /*QnA.sort(function(a, b) {
                            return (a.id - b.id);
                        });*/
            store.dispatch(actions.quickResponseUpdateSuccess(body, id));
            toast.success("Snabbsvar uppdaterad");
          } else {
            store.dispatch(actions.quickResponseUpdateFailure(err, res));
          }
        });
    };
  }
}

export default new QuickResponse();



// WEBPACK FOOTER //
// ./src/model/QuickResponse/model.js